class ProductListToggle extends window.BAO.CustomElement() {
  constructor() {
    super();

    this.triggerEl = this.querySelector(
      '[data-el="product-list-toggle.trigger"]'
    );
    this.contentEl = this.querySelector(
      '[data-el="product-list-toggle.content"]'
    );

    this.overlayEl = this.querySelector(
      '[data-el="product-list-toggle.overlay"]'
    );

    if (!this.triggerEl || !this.contentEl) return;

    this.triggerEl.addEventListener("click", this.handleTrigger);
    this.overlayEl.addEventListener("click", this.handleOverlayClick);
  }

  handleTrigger = () => {
    const pressed = this.triggerEl.getAttribute("aria-pressed") === "true";

    // Toggle overlay
    this.toggleOverlay(pressed);

    // Toggle aria-pressed
    this.togglePressed(pressed);

    // Toggle aria-expanded
    const expanded = this.contentEl.getAttribute("aria-expanded") === "true";
    this.toggleExpand(expanded);

    // Toggle button text
    this.toggleText(pressed);
  };

  handleOverlayClick() {
    this.togglePressed(true);
    this.toggleExpand(true);
    this.toggleText(true);
  }

  toggleExpand(expanded) {
    this.contentEl.setAttribute("aria-expanded", (!expanded).toString());
  }

  togglePressed(pressed) {
    this.triggerEl.setAttribute("aria-pressed", (!pressed).toString());
  }

  toggleText(pressed) {
    this.triggerEl.innerHTML = !pressed
      ? this.triggerEl.getAttribute("data-alternative-text")
      : this.triggerEl.getAttribute("data-default-text");
  }

  toggleOverlay(pressed) {
    this.overlayEl.setAttribute("aria-hidden", (pressed).toString());
  }
}

customElements.define("product-list-toggle", ProductListToggle);
